const integerSorter = (a, b) => parseInt(a, 10) - parseInt(b, 10);

export default integerSorter;
